export var VehicleStatusType;
(function (VehicleStatusType) {
    VehicleStatusType["HighWorkload"] = "HIGH WORKLOAD";
    VehicleStatusType["Idle"] = "IDLE";
    VehicleStatusType["LongIdle"] = "LONGIDLE";
    VehicleStatusType["Working"] = "WORKING";
    VehicleStatusType["Off"] = "OFF";
    VehicleStatusType["On"] = "ON";
    VehicleStatusType["N/A"] = "N/A";
})(VehicleStatusType || (VehicleStatusType = {}));
export var VEHICLE_WIDGET_STATUS_ENUM;
(function (VEHICLE_WIDGET_STATUS_ENUM) {
    VEHICLE_WIDGET_STATUS_ENUM["ACTIVE"] = "ACTIVE";
    VEHICLE_WIDGET_STATUS_ENUM["INACTIVE"] = "INACTIVE";
    VEHICLE_WIDGET_STATUS_ENUM["IDLE"] = "IDLE";
})(VEHICLE_WIDGET_STATUS_ENUM || (VEHICLE_WIDGET_STATUS_ENUM = {}));
export var VehicleWritingStatus;
(function (VehicleWritingStatus) {
    VehicleWritingStatus["PROCESSING"] = "PROCESSING";
    VehicleWritingStatus["WRITING"] = "WRITING";
})(VehicleWritingStatus || (VehicleWritingStatus = {}));
//# sourceMappingURL=vehicle.types.js.map